import { BasketRemoveOutlineIcon } from './BasketRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8DB42CB2-5A41-489E-BC04-1DFADF917DE6
 * name basket-remove-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-remove-outline.svg
 * tags
 * - Shopping 
 */
export const SkipRemoveOutlineIcon = BasketRemoveOutlineIcon;
export default SkipRemoveOutlineIcon